module.exports = __webpack_public_path__ + "media/images/gallery/constellations/bootes/boo_lines-bd5789483e3edab48b0b50b9be405d8a.gif";